"use client";

import React from "react";
import clsx from "clsx";
import {PiSpinner} from "react-icons/pi";

export type BUTTON_TYPE_DELETE = "button";

export function DeleteButton(
    { label, pendingLabel, pending, disabled, className, onClick, type = "submit" } : {
        label: string;
        pendingLabel?: string;
        pending?: boolean;
        disabled?: boolean;
        className?: string;
        onClick?: (() => void) | undefined;
        type?: "button" | "submit";
    }
) {

    return (
        <button type={type} onClick={() => {
            if(onClick) {
                onClick();
            }
        }} disabled={pending || disabled} aria-disabled={pending || disabled} aria-busy={!!pending} className={clsx(pending ? "animate-pulse bg-rose-600" : "bg-rose-600 hover:bg-rose-600/90", (pending || disabled) && "cursor-not-allowed opacity-80", "inline-flex items-center justify-center px-6 py-3 rounded-md text-center font-jost font-semibold outline-2 outline-offset-2 transition-colors text-lg text-white", className)}>
            <span className={clsx(pending ? "indent-[27px]" : "", "w-full")}>
                {pending && pendingLabel ? pendingLabel : label}
            </span>
            {pending && <PiSpinner className="animate-spin" size="2rem" color="#ffffff" />}
        </button>
    )

}
